// extracted by mini-css-extract-plugin
module.exports = {"Person":"PersonCard_Person__3NTjo","PersonImage":"PersonCard_PersonImage__2OA6S"};